import request from "../request";
import { baseURL8, baseURL2, baseURL10, baseURL16 } from "../baseUrl";
import { appToken } from "@/utils/util";

const request8 = request.build({
  baseURL: baseURL8,
  headers: { "Content-Type": "application/json" },
  transformRequest: [
    (data: any) => {
      return JSON.stringify(data);
    }
  ]
});
const request2 = request.build({
  baseURL: baseURL2,
  headers: {
    Authorization: appToken(),
    "Content-Type": "application/json"
  },
  transformRequest: [
    (data: any) => {
      return JSON.stringify(data);
    }
  ]
});

const request16 = request.build({
  baseURL: baseURL16,
  headers: { "Content-Type": "application/json" },
  transformRequest: [
    (data: any) => {
      return JSON.stringify(data);
    }
  ]
});

const request10 = request.build({
  baseURL: baseURL10,
  headers: { "Content-Type": "application/json", Authorization: appToken() },
  transformRequest: [
    (data: any) => {
      return JSON.stringify(data);
    }
  ]
});

const requestJson = request.build({
  baseURL: "https://imgvip.meishubao.com"
});
export interface resData<T = any> {
  data: T;
  msg: string;
  status?: number;
  code?: number;
  payload?: any;
  errors?: any;
}

export interface getAreaListData<T = any[]> {
  status: number;
  msg: string;
  data: T;
  result?: T;
}
interface getAreaListDataEntry<T = any[]> {
  status: number;
  msg: string;
  result: T;
}
interface teacherRegisterParam {
  mobile: string;
  code: string;
}
interface teacherRegisterSmsParam {
  mobile: string;
  area: string;
}
interface teacherSubmitParam {
  mobile: string;
  area: string;
}
interface teacherRegisterschoolP {
  key: string;
}
interface EntryGetTeacherInfo {
  id: string | number;
  step: string;
}
interface teacherIdentityInfoParam<T = any> {
  certName: string;
  certNo: string | number;
  facePicUrl: any;
  mobile: string;
}
// 请求的区域号码
export const getAreaList = () => {
  return request.post<getAreaListData>(
    "https://onlinepc.meishubao.com/api/pc/getAreaList"
  );
};

// 老师应聘信息注册登录
export const postTeacherRegister = (param: teacherRegisterParam) => {
  return request.post<getAreaListData>("/wxteacher/teacher_app_v2.html", {
    action: "login",
    openid: sessionStorage.getItem("openid"),
    ...param
  });
};
// 老师是否提交过应聘表单
export const postTeacherApplySubmit = (param: teacherSubmitParam) => {
  return request.post<getAreaListData>("/wxteacher/teacher_app_v2.html", {
    action: "getApplicat",
    openid: sessionStorage.getItem("openid"),
    ...param
  });
};
// 搜学校的
export const teacherRegisterschool = (param: any) => {
  return request.post<getAreaListData>("/wxteacher/teacher_app.html", {
    action: "get_school_list",
    ...param,
    openid: sessionStorage.getItem("openid")
  });
};
// 获取应聘信息的接口: boss预览
export const getApplicationInfo = (param: any) => {
  return request8.get<getAreaListData>(
    "/api/v1/teacher/apply/detail",
    {
      params: {
        ...param
      }
    }
  );
};
// 获取地址json
export const getAreaListJson = () => {
  return requestJson.get<getAreaListData>("/vip/h5/json/areaList.json");
};
// 获取地址json
export const AreaAddressListJson = () => {
  return requestJson.get<getAreaListData>("/vip/h5/json/area.json");
};
// 提交应聘信息的接口
export const registerApplicatSubmit = (param: any) => {
  return request.post<getAreaListData>("/wxteacher/teacher_app_v2.html", {
    action: "applicatsubmit",
    ...param,
    openid: sessionStorage.getItem("openid")
  });
};
// 教师入职第一个页面
export const teachetEntryGetTeacherInfo = (params: EntryGetTeacherInfo) => {
  return request.get<getAreaListDataEntry>(
    "/times/app/teacher/getTeacherInfo",
    {
      params: {
        ...params
      }
    }
  );
};

// 获取老师入职证书信息
export const getRecruitCertByApplyId = (params: {
  applyId: number | string;
}) => {
  return request16.get<any>(`/api/v1/teacher/recruit/getRecruitCertByApplyId`, {
    params
  });
};

// 修改老师入职证书信息
export const modifyCertInfo = (params: any[]) => {
  return request16.post<any>("/api/v1/teacher/recruit/modifyCertInfo", params);
};

// 保存教师入职的信息
export const teachetEntrySaveTeacherInfo = (params: any) => {
  return request.post<getAreaListDataEntry>(
    "/times/app/teacher/saveTeacherInfo",
    {
      ...params
    }
  );
};
// 预览教师入职的信息
export const teacherPreview = (params: any) => {
  return request.get<getAreaListDataEntry>(
    "/times/app/teacher/teacherPreview",
    {
      params: {
        ...params
      }
    }
  );
};

//判断教师是否签署协议
export const createTeacherContract = (params: {
  source: number;
  teacherId: number;
}) => {
  return request10.post<resData<any>>(
    "/contract/api/userContract/createTeacherContract",
    params
  );
};

// 金牌讲师的
export const getResumeTemplate = (params: any) => {
  return request.get<getAreaListDataEntry>("/times/app/teacher/teacherResume", {
    params: {
      ...params
    }
  });
};
// 同意审核
export const eacherInfoCheck = (params: any) => {
  return request.get<getAreaListDataEntry>(
    "/times/app/teacher/teacherInfoCheck",
    {
      params: {
        ...params
      }
    }
  );
};
// 获取 appid
export const getWxAuthorize = (params: any) => {
  console.log("获取 appid:", params);
  return request.get<getAreaListDataEntry>("/1v1h5app/getWxAuthorize.html", {
    params: {
      ...params
    }
  });
};
// 获取教师时段
export const teacherTimeSettings = (params?: any) => {
  return request.get("/times/app/teacher/timeSettings", {
    params: {
      ...params
    }
  });
};
// 老师预约考核考试：获取时间信息
export const getAppointmentInfo = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html#loading", {
    action: "get_date_info",
    openid: sessionStorage.openid,
    ...params
  });
};
// 老师预约考核考试：根据时间获取能预约的考官列表
export const getAppointmentExaminer = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html", {
    action: "examiner",
    openid: sessionStorage.openid,
    ...params
  });
};
// 老师预约考核考试：获取所有课件列表
export const getAppointmentCourseware = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html", {
    action: "courseware_list",
    openid: sessionStorage.openid,
    ...params
  });
};
// 老师预约考核考试：取消预约
export const cancelAppointment = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html", {
    action: "cancel_assessment",
    openid: sessionStorage.openid,
    ...params
  });
};
// 老师预约考核考试：获取更改预约时间是否是半小时之内的
export const getAppointmentHalfHour = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html", {
    action: "get_assessment_rule",
    openid: sessionStorage.openid,
    ...params
  });
};
// 老师预约考核考试：更改预约时间
export const changeAppointment = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html", {
    action: "update_assessment",
    openid: sessionStorage.openid,
    ...params
  });
};
// 老师预约考核考试：提交预约信息
export const submitAppointment = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html", {
    action: "save_assessment",
    openid: sessionStorage.openid,
    ...params
  });
};
// 老师预约考核考试：获取预约结果信息
export const getAppointmentResult = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html#loading", {
    action: "get_assessment_info",
    openid: sessionStorage.openid,
    ...params
  });
};
// 老师应聘：登录页面判断手机号是否已经入职
export const getMobileIsTeacher = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html#loading", {
    action: "getAdmin",
    openid: sessionStorage.openid,
    ...params
  });
};
// 应聘老师身份认证
export const teacherIdentityInfo = (params: teacherIdentityInfoParam) => {
  return request2.post<getAreaListData>(
    "/api/ali/h5SmartVerity/teacherIdentityInfo",
    {
      ...params
    }
  );
};
// 老师应聘：保存目前老师应聘节点
export const saveApplicationNode = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html#loading", {
    action: "save_node",
    openid: sessionStorage.openid,
    ...params
  });
};
// 老师应聘：校验手机号是否为应聘老师
export const checkTeacherPhone = (params?: any) => {
  return request.post("/wxteacher/teacher_app_v2.html#loading", {
    action: "getAdminByMob",
    ...params
  });
};
interface getTeacherLeaveStatusParams {
  mobile: string;
  idcard: string;
}
// 老师应聘信息获取老师是否已离职且不能再入职状态
export const getTeacherLeaveStatus = (params: getTeacherLeaveStatusParams) => {
  return request.get<getAreaListData>("/wxteacher/is_join", {
    params: {
      ...params
    }
  });
};
interface getApplicationViewParams {
  mobile: string;
}
export interface getApplicationViewExam {
  currentExamTimes: number;
  examStatus: number;
  examTimeStr: string;
  examinerName: string;
  roomPassword: string;
  score: number;
  assessmentId?: number;
}
export interface getApplicationViewRecruit {
  recruitId: number;
  status: number;
  submitTimeStr: string;
  unPassedReason: string;
}
/**
 * @description: 面试信息
 */
export interface getApplicationViewInterview {
  interviewTimeStr: string; // 预约面试时间字符串
  status: number; // 面试状态，0-不可预约、1-尚未预约、2-待面试、3-面试未通过、4-面试通过、5-自动放弃面试
  roomPassword: string; // 房间密钥
  interviewerName: string; // 面试官姓名
}
export interface getApplicationViewStagesItem {
  courseId: number;
  courseStatus: number;
  desc: string;
  examinedTimes: number;
  isPassed: number;
  learnLessons: number;
  score: string;
  stage: number;
  title: string;
  totalExamTimes: number;
  totalLessons: number;
}
interface getApplicationViewRes {
  applyId: number;
  applyRejectReason: string;
  applyStatus: number;
  applyTimeStr: string;
  hashApplyId: string;
  exam: getApplicationViewExam;
  recruit: getApplicationViewRecruit;
  stages: getApplicationViewStagesItem[];
  interview: getApplicationViewInterview;
  bizLine: string;
}
// 获取应聘信息总览
export const getApplicationView = (params: getApplicationViewParams) => {
  return request8.get<getAreaListData<getApplicationViewRes>>(
    "/api/v1/teacher/apply/flow",
    {
      params
    }
  );
};
interface getApplicationViewCoursewares {
  applyId: number;
}
// 查询应聘考核课件信息
export const getApplicationCourList = (
  params: getApplicationViewCoursewares
) => {
  return request8.get("/api/v1/teacher/apply/exam/coursewares", {
    params
  });
};
interface interviewGiveUpParams {
  applyId: number;
  reason: string;
  reasonId: number;
}
// 老师面试自主放弃
export const interviewGiveUp = (params: interviewGiveUpParams) => {
  return request8.post<getAreaListData>(
    "/api/v1/c/teacher/interview/give/up",
    params
  );
};
interface getInterviewAppointmentDateParams {
  applyId: number;
  week: string;
}
export interface getAppointmentWeekRes {
  dates: {
    dateStr: string;
    day: string;
    week: string;
    weekDesc: string;
  }[];
  examinerName: string;
  periods: {
    status: 0 | 1 | 2; // 0-已开放、1-已约考核、2-未开放
    timeInterval: string;
  }[];
}
// 获取面试预约日期信息
export const getInterviewAppointmentDate = (
  params: getInterviewAppointmentDateParams
) => {
  return request8.get<resData<getAppointmentWeekRes>>(
    "/api/v1/c/teacher/interview/time/periods",
    {
      params
    }
  );
};
interface saveInterviewAppointmentInfoParams {
  applyId: number;
  appointDate: string; // 预约日期，格式：yyyy-MM-dd
  timeInterval: string; // 时段信息，格式：HH:mm
  type: 0 | 1 | 2 | number; // 0: 第一次预约，1：用户主动修改，2：后台推送
}
// 保存面试预约信息
export const saveInterviewAppointmentInfo = (
  params: saveInterviewAppointmentInfoParams
) => {
  return request8.post<resData>(
    "/api/v1/c/teacher/interview/time/appoint",
    params
  );
};
interface getInterviewAppointmentResultParams {
  applyId: number;
}
// 老师面试预约结果
export const getInterviewAppointmentResult = (
  params: getInterviewAppointmentResultParams
) => {
  return request8.get("/api/v1/c/teacher/interview/time/detail", {
    params
  });
};
interface getInterviewAppointmentResultParams {
  applyId: number;
}
// 老师面试预约结果-取消面试
export const cancelInterview = (
  params: getInterviewAppointmentResultParams
) => {
  return request8.post("/api/v1/c/teacher/interview/cancel", params);
};
